import { T as f } from "./Tooltip-Cio21rv4.js";
export {
  f as default
};
